import { render, staticRenderFns } from "./RegistrationWithPeriod.vue?vue&type=template&id=4d71b53d&"
import script from "./RegistrationWithPeriod.vue?vue&type=script&lang=js&"
export * from "./RegistrationWithPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports